var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "relative w-full h-[300px]",
      on: { mouseenter: _vm.handleMouseEnter, mouseleave: _vm.handleMouseLeave }
    },
    [
      _vm.series.length > 0
        ? _c("apexchart", {
            ref: "chart",
            attrs: {
              type: "line",
              height: "275%",
              options: _vm.chartOptions,
              series: _vm.series
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.zoomEnabled && _vm.isHovered
        ? _c(
            "div",
            {
              staticClass:
                "absolute inset-0 z-10 flex items-center justify-center bg-white bg-opacity-50 backdrop-blur-sm cursor-pointer transition-opacity hover:bg-opacity-30",
              on: { click: _vm.enableZoom }
            },
            [
              _c(
                "span",
                { staticClass: "text-gray-900 font-semibold text-sm" },
                [_vm._v("Click to enable series zoom")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4 flex justify-center space-x-6" }, [
      _c("div", { staticClass: "flex items-center" }, [
        _c("div", { staticClass: "w-3 h-3 bg-green-500 rounded-full mr-2" }),
        _vm._v(" "),
        _c("span", { staticClass: "text-sm text-gray-600" }, [_vm._v("Costs")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex items-center" }, [
        _c("div", { staticClass: "w-3 h-3 bg-blue-500 rounded-full mr-2" }),
        _vm._v(" "),
        _c("span", { staticClass: "text-sm text-gray-600" }, [
          _vm._v("Deployments")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex items-center" }, [
        _c("div", { staticClass: "w-3 h-3 bg-red-500 rounded-full mr-2" }),
        _vm._v(" "),
        _c("span", { staticClass: "text-sm text-gray-600" }, [_vm._v("Alerts")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54ab4e56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54ab4e56","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/AICards/TimeSeriesCard/CombinedMetrics/CombinedMetricsGraphic.vue
// module id = null
// module chunks = 